export default __webpack_public_path__ + "d2a57ab70b7f369280cdb2587da89299.png";